export default {
  test1: "発注数量レポート",
  classificationReport: "分類数値レポート",
  test3: "全体数値レポート",
  aggregationCorrectionReport: "集計修正レポート",
};
